<div class="book-item-container">
    <div class="book-info">
        @if(book.bookCoverURL){
        <img [src]="book.bookCoverURL" alt="Capa do livro {{ book.bookTitle }}" class="book-cover">
        } @else{
        <img class="item-image" src="https://placehold.co/80x120/e0e0e0/333?text=Capa" [alt]="book.bookTitle"
            class="book-cover">
        }

        <div class="book-details">
            <p class="book-title">{{ book.bookTitle }}</p>
            <p class="book-type">{{ book.includesEbook ? 'eBook - Edição digital' : 'Livro Físico' }}</p>
            <p class="book-author">by {{ book.author }}</p>
            <p class="book-price">{{ book.totalPrice | currency:'BRL':'symbol':'1.2-2' }}</p>
        </div>
    </div>

    <div class="book-actions">
        <div class="quantity-control" *ngIf="book.includesBook">
            <button (click)="decreaseQuantity()">-</button>
            <input type="number" [value]="book.quantity" readonly>
            <button (click)="increaseQuantity()">+</button>
        </div>
        <div class="discount-section">
            @if(isAuthor) {
            <div class="author-badge">
                <span class="author-badge-icon">✓</span>
                <span class="author-badge-text">Autor</span>
            </div>
            <mat-form-field appearance="outline" class="discount-input">
                <mat-label>Desconto do autor</mat-label>
                <input matInput [value]="'Desconto automático'" disabled>
            </mat-form-field>
            } @else {
            <mat-form-field appearance="outline" class="discount-input">
                <mat-label>Código desconto do autor</mat-label>
                <input matInput [(ngModel)]="authorDiscountCode" (blur)="validateAndApplyDiscount()">
            </mat-form-field>
            }
            <small class="discount-message" [class.discount-success]="isAuthor">{{ discountMessage }}</small>
        </div>
    </div>
</div>